import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';

export default function ConfirmDialog(
  {open, onClose, text}: {open: boolean, onClose: any, text: string}
) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="preview-dialog-title"
      aria-describedby="preview-dialog-description"
    >
      <DialogTitle id="preview-dialog-title">{"Preview"}</DialogTitle>
      <DialogContent>
        <DialogContentText style={{whiteSpace: 'pre-line'}} id="preview-dialog-description">
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}